// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { alpha } from '@mui/material/styles';
import { sortFiles } from 'Utils/fileSort';
import { LAS_COLOR, PANO_COLOR } from 'Features/map/MapFileFootprints/footprintGeoJson';

// Extent numbers (D89): a file's number is its alphabetical rank within its
// OWN kind, padded to the kind's digit count (10 files -> 01..10, 150 ->
// 001..150). Numbers come from the full kind list - not just footprinted
// files - so a sidebar row and its map box always agree, and always from the
// name sort, so they hold steady when a pane is re-sorted by date.
export const numberLabel = (index: number, total: number): string =>
  String(index + 1).padStart(String(total).length, '0');

export const buildKindNumbers = (files: { id: string; name: string }[]): Map<string, string> => {
  const sorted = sortFiles(files, 'nameAsc', (file) => ({ name: file.name }));
  return new Map(sorted.map((file, index) => [file.id, numberLabel(index, sorted.length)]));
};

// The row chip's background: the kind's map color washed transparent (her
// call: a little oval in the kind's color, normal text inside). Cyan needs a
// touch more opacity to register as a tint. Values are live-tune candidates.
export const kindChipBg = (kind: FileSelectionKind, tifColor: string): string => {
  switch (kind) {
  case 'las':
    return alpha(LAS_COLOR, 0.15);
  case 'pano':
    return alpha(PANO_COLOR, 0.2);
  case 'poleImage':
    return alpha('#1C364B', 0.12);
  default:
    return alpha(tifColor, 0.28);
  }
};
